/**
 * StatusTag — Figma 387:5493 TagRoundFill
 *
 * 8개 상태 (pending/pickedup/visiting/pos/finishedMaking/preparing/rejected/paid)를
 * Figma 디자인 그대로 렌더링하는 공용 컴포넌트.
 *
 * 사용:
 *   <StatusTag state="pending" />
 *   <StatusTag state="visiting" hide={['visiting', 'pos']} />  // 처방전 관리 탭
 */
import { STATUS_TAG_DEFS } from '../../../constants/statusTags';

// 홈·처방전 관리 목록 상태 — Figma 15:6425/15:6505 tag/text: SB14 색 글자 (시안에 없는 상태는 태그 색)
// variant='outline' = 처방전 관리 상세 머리 (Figma 15:6505: 채움 없이 태그 색 테두리, h22 r16, SB14)
const TEXT_COLORS = {
  pending: '#fb8c00',
  pickedup: '#d4d4d8',
  finishedMaking: '#007aff',
  paid: '#55cf74',
  rejected: '#f04351',
  preparing: '#3f3f46',
  waiting: '#c254fe',
};

export default function StatusTag({ state, hide, variant }) {
  // 숨김 처리 (처방전 관리 탭에서 visiting/pos)
  if (hide && hide.includes(state)) return null;

  const def = STATUS_TAG_DEFS[state];
  if (!def) return null;

  if (variant === 'outline') {
    return (
      <span
        className="inline-flex items-center justify-center rounded-2xl border whitespace-nowrap"
        style={{
          height: 22,
          padding: '0 8px',
          borderColor: def.color,
          color: TEXT_COLORS[state] ?? def.color,
          fontSize: 'var(--text-14)',
          lineHeight: 'var(--text-14-lh)',
          fontWeight: 600,
        }}
      >
        {def.label}
      </span>
    );
  }

  if (variant === 'text') {
    return (
      <span
        className="whitespace-nowrap"
        style={{
          color: TEXT_COLORS[state] ?? def.color,
          fontSize: 'var(--text-14)',
          lineHeight: 'var(--text-14-lh)',
          fontWeight: 600,
          letterSpacing: '-0.28px',
        }}
      >
        {def.label}
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-center justify-center rounded-2xl border whitespace-nowrap"
      style={{
        height: 22,
        padding: '2px 8px',
        background: def.bg,
        borderColor: def.border,
        color: def.color,
        fontSize: 'var(--text-12)',
        lineHeight: '18px',
        fontWeight: def.weight,
      }}
    >
      {def.label}
    </span>
  );
}
